import { CallAPIAction, Status } from 'api/types'
import { PayForFarmerVisaResponse } from 'api/evisaAPI/farmerVisa'
import { PayfortBill } from 'common/types/transformedRespTypes'
import Actions from 'redux/actions'

type State = {
  status?: boolean
  bill?: PayfortBill
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.PAY_FOR_FARMER_VISA_ASYNC,
    Actions.PAY_FOR_FARMER_VISA_SUCCESS,
    Actions.PAY_FOR_FARMER_VISA_FAIL,
    PayForFarmerVisaResponse
  >,
): State => {
  switch (action.type) {
    case Actions.PAY_FOR_FARMER_VISA_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        status: payload.status,
        bill: {
          params: payload.bill.params,
          url: payload.bill.url,
        },
      }
    }
    case Actions.PAY_FOR_FARMER_VISA_ASYNC:
    case Actions.PAY_FOR_FARMER_VISA_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
